import {PlusOutlined} from '@ant-design/icons';
import Button from './Button';

const IncrementButton = (props) => {
  const buttonProps = {
    icon: <PlusOutlined/>,
    ...props,
  };

  return <Button {...buttonProps}/>;
};

export default IncrementButton;
